import axios from "axios";

export const deleteLocalBank = (
  localBankId: number,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/delete/one/tradexwbench.customer_settlement_bank/${localBankId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
